import React from 'react'
import './change-service-card.css'
import { HiHand, HiOutlinePencil } from "react-icons/hi";
import { useNavigation } from "../../../hooks/navigationContext";
import { useNavigate } from 'react-router-dom'

const ChangeServiceCard = ({ Action, Description, Duration, Price }) => {

    const navigate = useNavigate();
    const { setDirection } = useNavigation();

    const action = () => {
        setDirection(-1);
        navigate(Action);
    }

    return (
        <div>
            <button className='change-service-card' onClick={action}>

                <div className="card-icon">
                    <HiHand />
                </div>

                <div className="content">
                    <p className='app-little-title'>{Description}</p>
                    <div className="service-details">
                        <span className='clock'>⏱ </span>
                        <span className='app-little-text '>{Duration}</span>
                        <span className="app-little-text">•</span>
                        <span className="app-little-text price">{Price}</span>
                    </div>
                </div>

                <div className="change-icon">
                    Alterar&nbsp;<HiOutlinePencil />
                </div>
            </button>
        </div>
    )
}

export default ChangeServiceCard